import { render, staticRenderFns } from "./IndicationsView.vue?vue&type=template&id=3ef3618c&scoped=true"
import script from "./IndicationsView.vue?vue&type=script&lang=ts"
export * from "./IndicationsView.vue?vue&type=script&lang=ts"
import style0 from "./IndicationsView.vue?vue&type=style&index=0&id=3ef3618c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef3618c",
  null
  
)

export default component.exports